import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import styled, { css } from "styled-components";

const Value = styled.span`
    white-space: nowrap;
    color: limegreen;
    padding-left: 10px;
`;

const ElementValue = ({ value }) => {
    value = Number.parseFloat(value).toFixed(2);
    return (
        <Value>
            {value}
        </Value>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ElementValue));